export const getAbsoluteCoordinates = (
  node: SceneNode
): { x: number; y: number } => {
  const [[a, c, e], [b, d, f]] = node.absoluteTransform;
  const width = node.width;
  const height = node.height;

  // Transform all 4 corners
  const points = [
    { x: 0, y: 0 },
    { x: width, y: 0 },
    { x: 0, y: height },
    { x: width, y: height },
  ].map(({ x, y }) => ({
    x: a * x + c * y + e,
    y: b * x + d * y + f,
  }));

  // Find visual top-left (bounding box min x/y)
  const minX = Math.min(...points.map((p) => p.x));
  const minY = Math.min(...points.map((p) => p.y));

  return { x: minX, y: minY };
};
